import modules_Payment from './Payment/index.js'
import modules_model from './model/index.js'

export default {
    namespaced: true,
    modules:{
        model: modules_model,
        Payment: modules_Payment,
    },
}